import { w_speed_and_distance } from '../assets/colors'

const SpeedAndDistanceItem = ({ session, onClick, isSelected }) => {
  const handleSelect = (e) => {
    onClick(e)
  }

  let i = -1
  return (
    <>
      <tr
        onClick={(e) => handleSelect(e)}
        className={isSelected === true ? 'has-background-warning' : ''}
      >
        <td
          id={session.id}
          className="td-over has-text-left"
          style={{
            width: w_speed_and_distance[++i] + '%',
            maxWidth: w_speed_and_distance[i] + '%',
          }}
        >
          {session.date.toLocaleDateString()}
        </td>
        <td
          id={session.id}
          className="td-over has-text-centered"
          style={{
            width: w_speed_and_distance[++i] + '%',
            maxWidth: w_speed_and_distance[i] + '%',
          }}
        >
          {session.speed}
        </td>
        <td
          id={session.id}
          className="td-over has-text-centered"
          style={{
            width: w_speed_and_distance[++i] + '%',
            maxWidth: w_speed_and_distance[i] + '%',
          }}
        >
          {session.distance}
        </td>
        <td
          id={session.id}
          className="td-over has-text-left"
          style={{
            width: w_speed_and_distance[++i] + '%',
            maxWidth: w_speed_and_distance[i] + '%',
          }}
        >
          {session.rig}
        </td>
      </tr>
    </>
  )
}

export default SpeedAndDistanceItem
